import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';

@Component({
  selector: 'app-enrich-edit-form',
  templateUrl: './enrich-edit-form.component.html',
  styleUrls: ['./enrich-edit-form.component.css']
})

export class EnrichEditForm implements OnInit {
  constructor(
    private ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder
  ){}

  @Input()
  product;

  progressRef: NgProgressRef
  newMetaForm;

  get supplierMeta(){
    return Object.keys(this.product.supplierMeta)
  }
  
  ngOnInit() {
    this.progressRef = this.ngProgress.ref();
    const newForm = Object.keys(this.product.supplierMeta).reduce((acc, item) => {
      if(item !== "CODE"){
        acc[item] = [this.product.supplierMeta[item]]
      }
      return acc
    },{})
    this.newMetaForm = this.fb.group(newForm)
  }

  close(){
    this.activeModal.close()
  }

  save(){
    this.activeModal.dismiss({ productId: this.product.id, supplierMeta: this.newMetaForm.value })
  }
}